import moment from "moment";
import {
  ArrayField,
  AutocompleteArrayInput,
  ChipField,
  Datagrid,
  DateField,
  Filter,
  ReferenceArrayField,
  ReferenceArrayInput,
  ReferenceField,
  SearchInput,
  SingleFieldList,
  TextField,
  useListContext,
  useTranslate,
} from 'react-admin';
import { Permission, ReportList } from "../../components";
import ListPagination from "../../components/ListPagination";
import { filterToQuery } from "../../utils";
import { PERMISSIONS } from "../../constants";

const AttendantFilter = (props) => {
  const translate = useTranslate();
  return (
    <Filter {...props}>
      <SearchInput source="search" alwaysOn />
      <ReferenceArrayInput style={{ minWidth: 180 }} source="placeIds" reference="stations" perPage={9999} sort={{ field: "name", order: "ASC" }} emptyText="Todos" alwaysOn>
        <AutocompleteArrayInput
          filterToQuery={filterToQuery}
          optionText="name"
          label="Posto"
          sx={{ minWidth: 180, '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': { minWidth: 50 } }}
          noOptionsText={translate('ra.input.autocomplete.no_options_text')}
        />
      </ReferenceArrayInput>
    </Filter>
  );
};

const StationField = (props) => {
  if (!props.data) { return <></>; }
  const { data } = props;

  return (
    <>
      {Object.values(data).map(station => (
        <ReferenceField source="placeId" reference="stations" record={station}>
          <ChipField source="name" />
        </ReferenceField>)
      )}
    </>);
};

const FilterTablePrint = () => {
  const { filterValues } = useListContext();
  return (
    <Datagrid bulkActionButtons={false} data={[{ ...filterValues, generatedReportAt: moment().toISOString() }]} total={1}>
      <ReferenceArrayField source="placeIds" reference="stations" emptyText="Todos" textAlign="center" label="Posto" sortable={false} >
        <SingleFieldList>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
      <DateField source="generatedReportAt" textAlign="center" label="Gerado às" showTime sortable={false} locales="pt-BR" />
    </Datagrid>
  );
};

const ReportAttendant = (props) => {
  return (
    <Permission permission={PERMISSIONS.ATTENDANT_REPORT}>
      <ReportList
        {...props}
        basePath="report-attendant"
        title="Frentistas"
        resource="chains/chainId/reports/attendant"
        perPage={25}
        pagination={<ListPagination />}
        filters={<AttendantFilter />}
        filterTablePrint={<FilterTablePrint />}
        bulkActionButtons={false}
        titleOnPrint="Relatório de Frentistas"
      >
        <Datagrid bulkActionButtons={false}>
          <TextField source="name" label="Nome" textAlign="center" />
          <TextField source="identfid" label="Identfid" textAlign="center" />
          <ArrayField label="Postos" source="stationAttendants" sortable={false}>
            <StationField />
          </ArrayField>
        </Datagrid>
      </ReportList>
    </Permission>
  );
};

export default ReportAttendant;